import {FreeDataScenario} from './FreeDataScenario';

export class FreeDataValueScenario extends FreeDataScenario {}

